import React from 'react'
import { Button } from '@mui/material'
import { ReactComponent as BackIcon } from '../icons/back_icon.svg'

export default function BackToButton({ onClick, name }) {
  return (
    <Button onClick={onClick} sx={styles.button} startIcon={<BackIcon />} variant='text'>
      {name}
    </Button>
  )
}

const styles = {
  button: {
    fontWeight: 500,
    textTransform: 'none',
    fontSize: '16px',
    color: '#6123FF',
    fontFamily: 'Satoshi'
  }
}
